<template>
    <!-- <tr v-show="false first"></tr> -->
    <tr>
        <td>{{ user }}</td>

        <td v-if="!plain">{{ cash }}</td>

        <td v-if="!plain">{{ card }}</td>

        <td v-if="!plain">{{ total }}</td>

        <td v-if="!plain" style="text-align: center;">{{ worktime }}</td>
        <td v-else style="text-align: center;">{{  `${this.userReport.hours}:${this.userReport.minutes}` }}</td>
    </tr>
</template>

<script>
import ButtonActionSave from '@/components/ButtonActionSave'
import ButtonActionCloseEditing from '@/components/ButtonActionCloseEditing'
import ButtonActionDelete from '@/components/ButtonActionDelete'

export default {
  components: {
    ButtonActionSave,
    ButtonActionCloseEditing,
    ButtonActionDelete
  },
  props: {
    userReport: {
      type: Object
    },
    plain: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      card: 0,
      cash: 0,
      total: 0,
      user: '',
      worktime: ''
    }
  },
  computed: {
    isFirst () {
      return this.first
    },
    dateRowShown () {
      return !this.isFirst ? '' : this.startDate
    }
  },
  methods: {
    setCurrentRowData () {
      this.user = this.userReport.name
      this.cash = this.userReport.cash_payments
      this.card = this.userReport.card_payments
      this.total = (this.cash + this.card).toFixed(2)
      this.worktime = `${this.userReport.hours}:${this.userReport.minutes}`
      console.log(this.worktime)
      // this.user = this.userReport.user
    }
  },
  mounted () {
    console.log('mounted')
    this.setCurrentRowData()
  }
}
</script>
